import { Phone, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/site";

const FloatingActions = () => (
  <div className="fixed bottom-6 left-6 z-50 flex flex-col gap-3 md:hidden" data-testid="floating-actions">
    <a
      href={COMPANY.whatsappHref}
      target="_blank"
      rel="noreferrer"
      className="h-14 w-14 grid place-items-center rounded-full bg-[#25D366] text-white shadow-lg active:scale-95 transition-transform"
      aria-label="WhatsApp Cresttor Construction"
      data-testid="floating-whatsapp"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
    <a
      href={COMPANY.phoneHref}
      className="h-14 w-14 grid place-items-center rounded-full bg-crest-green text-white shadow-lg active:scale-95 transition-transform"
      aria-label="Call Cresttor Construction"
      data-testid="floating-call"
    >
      <Phone className="h-6 w-6" />
    </a>
  </div>
);

export default FloatingActions;
